import gql from 'graphql-tag'
import {
	user as userFragment,
	permissions as permissionsFragment
} from './fragments'

export default gql`
mutation createUser($required: UserReqFields!, $fields: UserFields) {
	cashAssist {
	  createMutation: createUser(required: $required, fields: $fields) {
			id
			mod_ver
			...usermain
			...permissions
			waiterKey
			cashRegisterId
		}
	}
}
${userFragment}
${permissionsFragment}`


